import { useMemo } from "react";
import { CroppingSuitabilityReportModel } from "@agroyaar/sdk";
import LineChart from "@/shared/components/charts/LineChart";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import { Table } from "@/shared/components/report-template/presentation/components/common/Table";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
import { averagesGddColumns } from "@/features/reports/presentation/components/cropping-suitability-multi-product/constants/average-gdd-header-table";

interface AveragesGddProps {
  croppingSuitabilityReports: CroppingSuitabilityReportModel[];
  chartYears: string[];
  pageNumber: number;
}

const AveragesGdd = ({
  croppingSuitabilityReports,
  chartYears,
  pageNumber,
}: AveragesGddProps) => {
  const series = useMemo(
    () =>
      croppingSuitabilityReports.map(
        ({ crop, annuallySuppliedGrowingDegreeDay }) => ({
          name: crop.persianName,
          data: annuallySuppliedGrowingDegreeDay.map(({ value }) => value),
        })
      ),
    [croppingSuitabilityReports]
  );

  return (
    <ReportTemplate serviceType="CROPPING_SUITABILITY" pageNumber={pageNumber}>
      <div className="w-full flex flex-col justify-between gap-3">
        <div className="w-full flex flex-col gap-2">
          <Title>درجه روز رشد تامین شده سالانه (GDD)</Title>
          <div className="w-full flex flex-col justify-center items-center gap-2 my-5">
            <LineChart
              yAxisTitle="درجه روز رشد (GDD)"
              labelsFontSize="10px"
              xAxisLabelsOptionsStep={1}
              categories={chartYears}
              series={series}
            />
            <Title>
              مقدار واحد دمایی محاسبه شده برای طول فصل در طی 30 سال گذشته
            </Title>
          </div>
        </div>
        <div className="w-full flex flex-col gap-2 mt-8">
          <Title>
            مقایسه میانگین GDD تامین شده در 30 سال گذشته با GDD مورد نیاز برای
            هر محصول
          </Title>

          <Table
            columns={averagesGddColumns}
            data={croppingSuitabilityReports}
          />
        </div>
      </div>
    </ReportTemplate>
  );
};

export default AveragesGdd;
